"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageBaseContextProvider = exports.LanguageBaseContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsIntlManager = require("../service/Intl/DmsIntlManager");
var _LanguageEnum = require("../constants/LanguageEnum");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LanguageBaseContext = exports.LanguageBaseContext = /*#__PURE__*/(0, _react.createContext)();

/**
 * @component
 * @name LanguageBaseContextProvider
 * @description
 * Context provider component that should wrap the entire application
 * to provide global access to the current language state.
 *
 * It should be used in `index.js` like this:
 * <LanguageBaseContextProvider>
 *   <App />
 * </LanguageBaseContextProvider>
 *
 * On mount, it:
 *  - Retrieves the system's default language.
 *  - Sets that language as the initial state.
 *  - Initializes `react-intl-universal` with the selected language.
 * 
 * How to use the context:
 *
 * To load the correct language when the app starts:
 * // In App.js
 *    const { language } = useContext(LanguageBaseContext);
 *    const [forcePage, setForcePage] = useState(0);
 *
 *
 *    useEffect(() => {
 *      const updateLanguage = async () => {
 *      await DmsIntlManager.init(language);
 *      setForcePage(prev => prev + 1)
 *    };
 * 
 *    updateLanguage();
 *  }, [language]);
 *
 * To update the language manually (e.g. from a settings page):
 * const { setLanguage } = useContext(LanguageBaseContext);
 * setLanguage('pt-BR'); // or 'en-US', etc.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - Children components that will have access to the context.
 *
 * @returns {JSX.Element} A provider with the values `{ language, setLanguage }`
 */
const LanguageBaseContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [language, setLanguage] = (0, _react.useState)(_LanguageEnum.Languages.EN_US);
  (0, _react.useEffect)(() => {
    const fetchLanguage = async () => {
      const userLang = await _DmsIntlManager.DmsIntlManager.getLanguage();
      setLanguage(userLang);
      await _DmsIntlManager.DmsIntlManager.init(userLang);
    };
    fetchLanguage();
  }, []);
  return /*#__PURE__*/_react.default.createElement(LanguageBaseContext.Provider, {
    value: {
      language,
      setLanguage
    }
  }, children);
};
exports.LanguageBaseContextProvider = LanguageBaseContextProvider;